/* eslint-disable react/prop-types */
import AccountCircle from '@mui/icons-material/AccountCircle'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import MenuIcon from '@mui/icons-material/Menu'
import { IconButton, MenuItem, Toolbar, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import SonyHDLogo from '../../../Assets/Images/sonyHDlogo.png'
import CONSTANTS from '../../../Constants'
import { getLocalStorage } from '../../../Helpers/Storage'
import { logout } from '../../../Helpers/Util'
import { useAppSelector } from '../../../Store/Hooks'
import NotificationsSSE from '../../Notifications/NotificationSSE'
import { AppBar, StyledMenu } from '../MUI-Drawer/MUI-Drawer-Style'
import { BlitzLogo } from '../MUI-Drawer/MUI-Drawer.svgIcons'
import MUITooltip from '../MUI-Tooltip'
import AccountDrawer from './AccountDrawer'
import AdvanceSearch from './AdvanceSearch'
import './header.scss'
import NotifPopper from './NotifPopper'

const Header: React.FC<{ setOpen?: any; drawerState?: boolean; sidebar?: boolean }> = ({
  setOpen = () => {
    return
  },
  drawerState = false,
  sidebar = true,
}) => {
  const navigate = useNavigate()
  const { cmsConfig } = useAppSelector((state) => state.appConfig)

  const [drawerOpen, setDrawerOpen] = useState(false)
  const [userData, setUserData] = useState<any>({})
  const [notificationAnchorEl, setNotificationAnchorEl] = useState<null | HTMLElement>(null)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  useEffect(() => {
    const userData = getLocalStorage(CONSTANTS.LOCAL_KEYS.USER_DATA)
    setUserData(userData)
  }, [drawerState])

  const handleShowNotifications = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationAnchorEl(event.currentTarget)
  }

  const renderAccountIcon = (openDrawer: boolean) => {
    return (
      <MUITooltip title='View profile & settings' placement='bottom'>
        <IconButton
          size='large'
          aria-label='account of current user'
          aria-controls='menu-appbar'
          aria-haspopup='true'
          color='inherit'
          onClick={() => (openDrawer ? setDrawerOpen(true) : '')}
        >
          <AccountCircle />
        </IconButton>
      </MUITooltip>
    )
  }

  return (
    <AppBar position='fixed' open={drawerState} style={{ backgroundColor: '#191D23' }}>
      <Toolbar className='justify-content-between'>
        <div className='d-flex'>
          {sidebar && (
            <IconButton
              color='inherit'
              aria-label='open drawer'
              onClick={() => {
                setOpen(!drawerState)
              }}
              edge='start'
              sx={{
                marginRight: 2,
              }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <img
            data-testid='sony-logo'
            src={SonyHDLogo}
            style={{ width: '32px', height: '32px' }}
            alt='sony-logo'
            onClick={() => navigate('/home')}
            className='cursor-pointer'
          />
          <Typography
            data-testid='blitz-logo'
            component='div'
            sx={{ flexGrow: 1, marginLeft: 2, cursor: 'pointer' }}
            onClick={() => navigate('/home')}
          >
            <BlitzLogo />
          </Typography>
        </div>
        <AdvanceSearch />
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {cmsConfig.ENABLED_FEATURES?.NOTIFICATIONS ? (
            <>
              <div className='notification-container'>
                <IconButton size='large' color='inherit' onClick={handleShowNotifications}>
                  <MUITooltip title='View Notifications' placement='left'>
                    <NotificationsSSE />
                  </MUITooltip>
                </IconButton>
                {notificationAnchorEl && (
                  <NotifPopper
                    notificationAnchorEl={notificationAnchorEl}
                    setNotificationAnchorEl={setNotificationAnchorEl}
                    navigate={navigate}
                  />
                )}
              </div>
              {renderAccountIcon(true)}
            </>
          ) : (
            <>
              <Typography style={{ fontSize: '14px', fontWeight: '600' }}>
                {userData?.userName}
              </Typography>

              {renderAccountIcon(false)}
              <span
                className='profile-arrow-down-icon'
                onClick={(event: any) => {
                  setAnchorEl(event.currentTarget)
                }}
                data-testid={'account-dropdown'}
              >
                <KeyboardArrowDownIcon />
              </span>
            </>
          )}
        </div>
        {drawerOpen && <AccountDrawer setDrawerOpen={setDrawerOpen} userData={userData} />}
        {anchorEl && (
          <StyledMenu
            id='demo-customized-menu'
            MenuListProps={{
              'aria-labelledby': 'demo-customized-button',
            }}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem onClick={logout} disableRipple>
              Logout
            </MenuItem>
          </StyledMenu>
        )}
      </Toolbar>
    </AppBar>
  )
}

export default Header
